import z from "zod";
import { labelSchema } from "../label";
import { PreAnnotateModelTypeEnum, PreAnnotateProviderEnum, } from "../preAnnotateSettings/preAnnotateSettings.schema";
export var AutoAnnotationGeometryEnum;
(function (AutoAnnotationGeometryEnum) {
    AutoAnnotationGeometryEnum["RECTANGLE"] = "RECTANGLE";
    AutoAnnotationGeometryEnum["POLYGON"] = "POLYGON";
})(AutoAnnotationGeometryEnum || (AutoAnnotationGeometryEnum = {}));
export const autoAnnotationSchema = z.object({
    id: z.number(),
    label: labelSchema,
    geometry: z.enum(AutoAnnotationGeometryEnum),
    score: z.number().nullable(),
    x: z.number().nullable(),
    y: z.number().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    value: z.tuple([z.number(), z.number()]).array().nullable(),
    provider: z.enum(PreAnnotateProviderEnum),
    modelType: z.enum(PreAnnotateModelTypeEnum),
    modelId: z.number().nullable(),
    createdAt: z.iso.datetime(),
});
//# sourceMappingURL=auto-annotation.schema.js.map